// @flow

export const iconColor = (success: boolean) => ({
  color: success ? "#4caf50" : "#ff3d00",
  fontSize: 20,
  paddingLeft: 5,
  paddingRight: 5,
});
